import getComposeLinkViewState from './getComposeLinkViewState';
export default function isContextMenuOpen(linkId) {
    var composeLinkViewState = getComposeLinkViewState(linkId);
    return composeLinkViewState ? composeLinkViewState.isContextMenuOpen : false;
}
//# sourceMappingURL=isContextMenuOpen.js.map